import ExportReadyToast from '@/components/Studies/StudyExports/ExportReadyToast/ExportReadyToast';
import { errorToast, successToast } from '@/helpers.tsx';
import { useTeamEvent } from '@/support/teamEvents/useTeamEvent';
import { type FC } from 'react';

const ExportGeneratedToastListener: FC = () => {
  useTeamEvent('export_generated', (event) => {
    if (event.status === 'completed') {
      successToast(({ closeToast }) => <ExportReadyToast event={event} onDismiss={closeToast} />, {
        closeOnClick: false,
        autoClose: 15_000,
      });
    } else if (event.status === 'failed') {
      errorToast('Your export failed. Please try again or contact support if the issue persists.');
    }
  });

  return null;
};

export default ExportGeneratedToastListener;
